module.exports = __webpack_public_path__ + "static/media/highlight-silver.197456ef.svg";